import {AfterViewInit, Component, OnInit} from '@angular/core';
import {redirectToLink} from '../../common/constants';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Meta, Title} from '@angular/platform-browser';
import {SessionService} from '../../../services/session.service';
import {Router} from '@angular/router';

declare var hbspt: any;

@Component({
    selector: 'app-cumplimiento-juridico',
    templateUrl: './cumplimiento-juridico.component.html',
    styleUrls: ['./cumplimiento-juridico.component.scss']
})
export class CumplimientoJuridicoComponent implements AfterViewInit, OnInit {
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private deviceService: DeviceDetectorService,
        private sessionService: SessionService,
        private router: Router,
        private metas: Meta,
        private titlePage: Title
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        const TITLE = 'Conheça a validade jurídica do FAD® | A única Assinatura Autógrafa Digital®';
        const DESCRIPTION = 'A Assinatura Autógrafa Digital® está em conformidade com a Medida Provisória No 2.200-2, LGPD, as leis da UNCITRAL (ONU) e os novos regulamentos eIDAS, US ESIGN e UETA & ESIGN Act, entre outros regulamentos.';
        const URL = 'https://www.assinaturaautografadigital.com.br/conformidade-legal-da-assinatura-digital';
        const IMG = 'https://hola.firmaautografa.com/hubfs/BRASIL-ASSETS/METAS-PLACE-BRASIL-PAGES/validez.png';
        this.titlePage.setTitle(TITLE);
        /* PRINCIPALES */
        this.metas.updateTag({
            name: 'keywords',
            content: 'validez de la firma digital, firma digital legal'
        });
        this.metas.updateTag({
            name: 'description',
            content: DESCRIPTION
        });
        /* FACEBOOK Y LINKEDIN */
        this.metas.updateTag({
            property: 'og:url',
            content: URL
        });
        this.metas.updateTag({
            property: 'og:title',
            content: TITLE
        });
        this.metas.updateTag({
            property: 'og:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            property: 'og:image',
            content: IMG
        });
        /* TWITTER */
        this.metas.updateTag({
            name: 'twitter:title',
            content: TITLE
        });
        this.metas.updateTag({
            name: 'twitter:description',
            content: DESCRIPTION
        });
        this.metas.updateTag({
            name: 'twitter:image',
            content: IMG
        });
        window.scrollTo(0, 0);
    }

    ngAfterViewInit(): void {
    }

    goTo(link): void {
        redirectToLink(link);
    }

    ngOnInit(): void {
        hbspt.forms.create({
            region: 'na1',
            portalId: '5707307',
            formId: '943c40a1-b0d7-4483-ae11-99a078eabcaa',
            target: '#form-legal'
        });
    }

    enviarDownloadCumplimiento(country: string): void {
        this.sessionService.setDownloadCumplimiento(country);
        this.router.navigate(['conformidade-legal-da-assinatura-digital/descarga-el-tuyo']);
    }
}
